import { render, staticRenderFns } from "./AddOpinion.vue?vue&type=template&id=382ee2ca&scoped=true"
import script from "./AddOpinion.vue?vue&type=script&lang=js"
export * from "./AddOpinion.vue?vue&type=script&lang=js"
import style0 from "./AddOpinion.vue?vue&type=style&index=0&id=382ee2ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "382ee2ca",
  null
  
)

export default component.exports